import { Component, NgZone, OnDestroy, Input } from "@angular/core";
import { Subscription } from "rxjs";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { AbsencesDirectService, AbsencesDirectServiceData } from "../../services/absencesKpi/absencesDirect.service";
import { AbsencesDirectDetailService, AbsencesDirectDetailServiceData, AbsencesDirectDetailServiceDataItem } from "../../services/absencesKpi/absencesDirectDetail.service";
import { ColumnDefinition, TextColumnDefinition, RowStyle, DateColumnDefinition, PhoneNumberColumnDefinition, EmailColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import "../../../../util/array";
import moment from 'moment';
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

export class AbsencesDirectData {
  public consultant: number;
  public office: number;

  constructor(consultant: number, office: number) {
    this.consultant = consultant;
    this.office = office;
  }
}

export class AbsencesDirectDetailData {
  public columnDefinitions: ColumnDefinition[];
  public tabledata: any[][];
  public rowStyleSelector: (x) => RowStyle;

  constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
    this.columnDefinitions = columnDefinitions;
    this.tabledata = tabledata;
    this.rowStyleSelector = (x) => {
      if (x[9] == "A") return new RowStyle("red", "white");
      else return new RowStyle("black", "white");
    }
  }
}

@Component({
    selector: 'absences-direct-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class AbsencesDirectKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<AbsencesDirectService, AbsencesDirectServiceData, AbsencesDirectData, AbsencesDirectDetailService, AbsencesDirectDetailServiceData, AbsencesDirectDetailData>
  implements OnDestroy {
  public getClassName() { return "AbsencesDirectKpiServiceHostComponent"; }

  private raasSubscription: Subscription;
  private officeSelectorSubscription: Subscription;
  @Input() public detailDialog: ModalDialogComponent;

  constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
    summaryService: AbsencesDirectService, detailService: AbsencesDirectDetailService) {
    super(zone, logger, summaryService, detailService);
    this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
    this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
  }

  protected processSummaryData(data: AbsencesDirectServiceData): AbsencesDirectData {
    return new AbsencesDirectData(data.consultant, data.office);
  }

  protected getDefaultSummaryData(): AbsencesDirectData {
    let data = new AbsencesDirectData(0, 0);
    return data;
  }

  protected extractUpdateTime(data: AbsencesDirectServiceData): Date {
    return data.updateTimestamp;
  }

  protected processDetailData(data: AbsencesDirectDetailServiceData, args: any): AbsencesDirectDetailData {
    if (data.absences) {
      if (args && args.filter && args.filter.consultant) {
        let columnDefinitions = this.getColumnsDefault(true);

        let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

        if (args && args.filter) {
          if (args.filter.consultant) {
            let consultantName = (this.extractConsultants(data.absences).find(x => x.nif == consultantNif) || { name: null }).name;
            columnDefinitions[8].filterTerm = [consultantName];
          }
          if (args.filter.date) columnDefinitions[0].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
        }

        let tabledata2 = [];
        let tabledata = [];

        for (let absence of data.absences) {
          if (absence.nif.toUpperCase() == consultantNif) {
            tabledata.push([
              absence.absenceDate,
              absence.absenceDescription,
              absence.contractBeginDate,
              absence.trialPeriodEndDate,
              absence.workerName,
              absence.workerPhone,
              absence.workerEmail,
              absence.client,
              absence.name,
              absence.category
            ]);
          }
          else {
            tabledata2.push([
              absence.absenceDate,
              absence.absenceDescription,
              absence.contractBeginDate,
              absence.trialPeriodEndDate,
              absence.workerName,
              absence.workerPhone,
              absence.workerEmail,
              absence.client,
              absence.name,
              absence.category
            ]);
          }
        }
        let arrayOrdenado = tabledata.concat(tabledata2);
        return new AbsencesDirectDetailData(columnDefinitions, arrayOrdenado);
      } else {
        let columnDefinitions = this.getColumnsDefault(false);

        let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

        if (args && args.filter) {
          if (args.filter.consultant) {
            let consultantName = (this.extractConsultants(data.absences).find(x => x.nif == consultantNif) || { name: null }).name;
            columnDefinitions[0].filterTerm = [consultantName];
          }
          if (args.filter.date) columnDefinitions[1].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
        }

        let tabledata2 = [];
        let tabledata = [];

        for (let absence of data.absences) {
          if (absence.nif.toUpperCase() == consultantNif) {
            tabledata.push([
              absence.name,
              absence.absenceDate,
              absence.absenceDescription,
              absence.contractBeginDate,
              absence.trialPeriodEndDate,
              absence.workerName,
              absence.workerPhone,
              absence.workerEmail,
              absence.client,
              absence.category
            ]);
          }
          else {
            tabledata2.push([
              absence.name,
              absence.absenceDate,
              absence.absenceDescription,
              absence.contractBeginDate,
              absence.trialPeriodEndDate,
              absence.workerName,
              absence.workerPhone,
              absence.workerEmail,
              absence.client,
              absence.category
            ]);
          }
        }
        let arrayOrdenado = tabledata.concat(tabledata2);
        return new AbsencesDirectDetailData(columnDefinitions, arrayOrdenado);
      }
    }
    else return this.getDefaultDetailData();
  }

  protected getDefaultDetailData(): AbsencesDirectDetailData {
    let columnDefinitions = this.getColumnsDefault(false);

    columnDefinitions[0].sortable = false;

    return new AbsencesDirectDetailData(columnDefinitions, []);
  }

  protected performDetailAction(): void {
    if (this.detailDialog) this.detailDialog.open();
  }

  public ngOnDestroy(): void {
    if (this.raasSubscription) this.raasSubscription.unsubscribe();
    if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
  }

  public mergeFilter(filter: any) {
    let detailProcessingArgs = this.detailProcessingArgs || {};
    detailProcessingArgs.filter = detailProcessingArgs.filter || {};
    detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
    this.detailProcessingArgs = detailProcessingArgs;
  }

  private extractConsultants(data: AbsencesDirectDetailServiceDataItem[]): { nif: string, name: string }[] {
    let nifs: { nif: string, name: string }[] = [];

    if (data) {
      data.forEach(x => {
        if (!nifs.find(y => x.nif.toUpperCase() == y.nif)) nifs.push({ nif: x.nif.toUpperCase(), name: x.name });
      })
    }

    return nifs;
  }

  /**
   * Método que define las columnas, sus etiquetas y medidas
   * @param consultant Indica si se esta visualizando por consultor caso contrario oficina
   * @returns Arreglo de columnas por defecto para la grilla
   */
  public getColumnsDefault(consultant): any {
    let columnDefinitions = [
      new DateColumnDefinition("Fecha baja", (data) => moment(data).format("DD/MM/YYYY"), true),
      new TextColumnDefinition("Tipo baja", null, true),
      new DateColumnDefinition("Fecha contrato", (data) => moment(data).format("DD/MM/YYYY"), true),
      new DateColumnDefinition("Fin per. \nprueba", (data) => {
        let date = moment(data);
        let strDate = date.format("DD/MM/YYYY");
        if (strDate == "01/01/1900" || moment().isAfter(date)) return "Superado";
        else return strDate;
      }, true, 90),
      new TextColumnDefinition("Trabajador"),
      new PhoneNumberColumnDefinition("Teléfono"),
      new EmailColumnDefinition("Email"),
      new TextColumnDefinition("Cliente", null, true),
    ];

    if (consultant) {
      columnDefinitions.push(new TextColumnDefinition("Consultor", null, true));
    } else {
      columnDefinitions = [new TextColumnDefinition("Consultor", null, true), ...columnDefinitions];
    }

    return columnDefinitions;
  }
}
